/**
 * Terms & Conditions modal — triggered from the contact-card block.
 * The trigger button and the modal both carry data attributes; no coupling to
 * the sign-up form module.
 */
export function initTcModal() {
  const trigger = document.querySelector('[data-emc-tc-trigger]');
  const modal   = document.querySelector('[data-emc-tc-modal]');
  if (!trigger || !modal) return;

  const closeBtn = modal.querySelector('[data-emc-tc-close]');

  const open = () => {
    modal.hidden = false;
    closeBtn?.focus();
  };

  const close = () => {
    modal.hidden = true;
    history.replaceState(null, '', window.location.pathname + window.location.search);
    trigger.focus();
  };

  trigger.addEventListener('click', open);
  closeBtn?.addEventListener('click', close);
  modal.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  // Open on page load when #terms is in the URL.
  if (window.location.hash === '#terms') {
    open();
  }
}
